import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { createTheme, makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import Container from "@material-ui/core/Container";
import { useHistory } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
const axios = require("axios");
const Cookies = require("js-cookie");

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const theme = createTheme({
  palette: {
    primary: { main: "#26477c" },
  },
});

export default function SignIn() {
  const classes = useStyles();

  let [username, setUserName] = useState("");
  let [password, setPassword] = useState("");
  let [errorMsg, setErrorMsg] = useState("");

  let authObj = Cookies.get("authObj");
  let history = useHistory();

  if (authObj) {
    history.push("/dashboard");
  }

  const handleLoginChange = (event) => {
    let eventName = event.target.name;
    switch (eventName) {
      case "username":
        setUserName(event.target.value);
        break;
      case "password":
        setPassword(event.target.value);
        break;
      default:
        console.log("default");
    }
  };

  let errorMsgJSX = <></>;

  if (errorMsg) {
    errorMsgJSX = (
      <div>
        <div>&nbsp;</div>
        <Alert severity="error">{errorMsg}</Alert>
      </div>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          {errorMsgJSX}
          <form className={classes.form} noValidate>
            <TextField
              onChange={(event) => {
                handleLoginChange(event);
              }}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="username"
              label="User Name"
              name="username"
              autoComplete="username"
              autoFocus
            />
            <TextField
              onChange={(event) => {
                handleLoginChange(event);
              }}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            {/* <FormControlLabel
            control={<Checkbox value='remember' color='primary' />}
            label='Remember me'
          /> */}
            <Button
              // type='submit'
              onClick={() => {
                let body = {};
                body["username"] = username;
                body["password"] = password;

                axios
                  .post(`${process.env.REACT_APP_API}/loginUser`, body)
                  .then((result) => {
                    let authObj = {
                      token: result.data.token,
                      success: result.data.success,
                      error: result.data.message,
                    };
                    if (result.data.success) {
                      Cookies.set("authObj", authObj);
                      authObj["userType"] = result.data.usertype;
                      authObj["organisation"] = result.data.organisation;
                      setTimeout(() => {
                        if (result.data.success) {
                          history.push("/dashboard");
                        }
                      }, 1000);
                      // history.push('/dashboard');
                    } else {
                      let errorMsg =
                        authObj["error"] ||
                        "Please sign in with correct user creditials";
                      setErrorMsg(errorMsg);
                    }

                    if (!body["username"]) {
                      setErrorMsg("Please input a username");
                    }

                    if (!body["password"]) {
                      setErrorMsg("Please input a password");
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }}
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link
                  href="#"
                  variant="body2"
                  onClick={() => {
                    history.push("/reset_password");
                  }}
                >
                  Forgot password?
                </Link>
              </Grid>
              {/* <Grid item>
              <Link href='#' variant='body2'>
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid> */}
            </Grid>
          </form>
        </div>
        <Box mt={8}>{/* <Copyright /> */}</Box>
      </Container>
    </ThemeProvider>
  );
}
